/* eslint-disable */
import { DocumentNode } from 'graphql';

const clientAlwaysDirectiveValue = {
    kind: 'Directive',
    name: { kind: 'Name', value: 'client' },
    arguments: [{
        kind: 'Argument',
        name: { kind: 'Name', value: 'always' },
        value: { kind: 'BooleanValue', value: true },
    }],
};

export const addClientAlwaysDirectiveLogic = (doc: DocumentNode): DocumentNode => {
    return {
        ...doc,
        definitions: doc.definitions.map((node: any) => ({
            ...node,
            ...(node.kind === 'OperationDefinition' ? {
                selectionSet: {
                    ...node.selectionSet,
                    selections: node.selectionSet.selections.map((selection: any) => ({
                        ...selection,
                        directives: [
                            ...(selection.directives ? selection.directives : []),
                            clientAlwaysDirectiveValue,
                        ],
                    })),
                },
            } : {}),
        })),
    };
}
